import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';

type FieldHelpTextProps = {
    /**
     * Translation key. The string may contain <strong> to emphasise the lead-in,
     * which i18next renders through <Trans /> without extra components.
     */
    i18nKey: string;
    className?: string;
};

/**
 * Explanatory caption rendered under a form field or section heading.
 */
export function FieldHelpText({
    i18nKey,
    className,
}: FieldHelpTextProps): React.ReactElement {
    return (
        <Typography
            variant="caption"
            component="p"
            className={`mt-1 block leading-snug text-gray-600 ${className ?? ''}`}
        >
            <Trans i18nKey={i18nKey} />
        </Typography>
    );
}
